export default "__VITE_ASSET__BCu5R_7e__"